import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import i18n from '@/translate/i18n'
import FlagIcon from 'vue-flag-icon'
import CountryFlag from 'vue-country-flag'
import global_utilities from "./mixins/global/global_utilities";
import store from "./vuex/store";
import VueCryptojs from "vue-cryptojs";
import axios from "axios";

import ToggleButton from 'vue-js-toggle-button'

import Breadcrumbs from '@/components/Breadcrumbs.vue'
import SuccessDialog from '@/components/SuccessDialog.vue'
import PermissionDialog from '@/components/PermissionDialog.vue'
import DeleteConfirmDialog from '@/components/DeleteConfirmDialog.vue'

import {initializeApp} from "firebase/app";
import {getAnalytics, logEvent} from "firebase/analytics";

import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

axios.defaults.headers.common["Authorization"] =
  "Bearer " + sessionStorage.getItem("token");
Vue.prototype.$axios = axios;


const firebaseConfig = {
  apiKey: "AIzaSyBkrXNB6N6omLg2OCpCQAmJZJD00cgIdV0",
  authDomain: "fusionseed-c367b.firebaseapp.com",
  projectId: "fusionseed-c367b",
  storageBucket: "fusionseed-c367b.appspot.com",
  messagingSenderId: "929354132948",
  appId: "1:929354132948:web:4fda469953e26e0ef0fa41",
  measurementId: "G-LPFY00R5Q1"
};

// Initialize Firebase
 const app =initializeApp(firebaseConfig);
const analytics = getAnalytics( );
console.log(app);
//Vue.prototype.$base_url = 'https://devseedwebapi.azurewebsites.net/api/v1/'

Vue.prototype.$analytics = analytics;
Vue.component('Breadcrumbs', Breadcrumbs),
Vue.component('SuccessDialog', SuccessDialog)
Vue.component('DeleteConfirmDialog', DeleteConfirmDialog)
Vue.component('PermissionDialog', PermissionDialog)
Vue.component('country-flag', CountryFlag)
Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.use(ToggleButton)
Vue.use(FlagIcon)
Vue.use(VueCryptojs);
Vue.mixin(global_utilities);

Vue.config.productionTip = false
window.addEventListener('beforeunload',function(){
 this.logout();
});
new Vue({
  methods:{
    logEvent_tab(EventName){
      logEvent(this.$analytics,EventName);
    },
    logout() {
      localStorage.setItem("vivek_authenticated_user_data", "");
      localStorage.setItem("vivek_token", "");
      localStorage.clear();
      sessionStorage.removeItem("token");
      this.$router.push({ path: "/login", query: { db_locale: i18n.locale } });
      let expire = "Thu, 01 Jan 1970 00:00:00 GMT;";
      document.cookie = "langprod=;" + ";expires=" + expire;
      document.cookie = "flagprod=;" + ";expires=" + expire;
      document.cookie = "titleprod=;" + ";expires=" + expire;
      document.cookie = "highlighted=;" + ";expires=" + expire;
    }
  },
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
